import { AnyAction } from 'redux';
import { App, TkvVorbelegungdaten } from '@ps20-frontend/frontend-models';
import { isNeugeschaeft } from '@ps20-frontend/shop-integration-redux';
import { TkvActions } from '../tkvActions';
import { IAppState } from '../appState';

export interface Vorbelegungen {
  adresseImmobilieVorbelegt: boolean;
  versicherungsnehmerVorbelegt: boolean;
  disabledFields?: DisabledFields;
}

export interface DisabledFields {
  geburtsdatum: boolean;
  tierKastriert: boolean;
  tierart: boolean;
  geschlecht: boolean;
  rasse: boolean;
}

export const vorbelegungenReducer = function (
  sectionState: Vorbelegungen = null,
  action: AnyAction,
  state: IAppState,
): Vorbelegungen {
  switch (action.type) {
    case TkvActions.PLZ_CHANGED: {
      return {
        ...sectionState,
        adresseImmobilieVorbelegt: false,
      };
    }
    case TkvActions.VORBELEGUNG_FOR_TKV_ERSATZ_REQUESTED: {
      const actionPayload: TkvVorbelegungdaten = action.payload;
      const isErsatz = !isNeugeschaeft(state.vertragsoptionen);
      if (actionPayload.forApp === App.TKV && actionPayload.angebotsId === state.angebotsId) {
        return {
          ...sectionState,
          adresseImmobilieVorbelegt: true,
          disabledFields: {
            geburtsdatum: !!(actionPayload.geburtsdatumTier && isErsatz),
            tierKastriert: !!(actionPayload.isKastriert && isErsatz),
            tierart: !!(actionPayload.tierart && isErsatz),
            geschlecht: !!(actionPayload.tiergeschlecht && isErsatz),
            rasse: !!(actionPayload.tierrasse && isErsatz),
          },
        };
      }
      return sectionState;
    }
    default:
      return sectionState;
  }
};
